define('plugin/paid-attributes/view/step/AttributeListView',['require','marionette','plugin/paid-attributes/view/step/AttributeItemView','lib/view/UnwrapBehavior','Config'],function (require) {

    var Parent = require('marionette').CompositeView;
    var AttributeItemView = require('plugin/paid-attributes/view/step/AttributeItemView');
    var UnwrapBehavior = require('lib/view/UnwrapBehavior');
    var Config = require('Config');

    /**
     * Products composite view (products container)
     *
     * @class ProductListView
     */
    return Parent.extend({

        template: '#paid_attribute_step_list_view',
        childView: AttributeItemView,
        childViewContainer: '#sb_attribute_list_container',
        
        childViewOptions: function (model, index) {
            var service = this.getOption('bookingModel').get('service');
            return {
                hide_duration: service && service.hide_duration
            };
        },
        
        collectionEvents: {
            sync: 'safeRender'
        },
        
        behaviors: {
            UnwrapBehavior: {
                behaviorClass: UnwrapBehavior
            }
        },
        
        initialize: function () {
            Parent.prototype.initialize.apply(this);

            var bookingModel = this.getOption('bookingModel');
            this.listenTo(bookingModel, 'change:service', this.safeRender);

            if (Config.getInstance().getBooleanOption('paid_attributes_exclusive')) {
                this.listenTo(this.collection, 'change:qty', this._onExclusiveQtyChange);
            }
        },

        _onExclusiveQtyChange: function (model) {
            if (model.get('qty') > 0) {
                this.collection.each(function (item) {
                    if (item !== model && item.get('qty') > 0) {
                        item.set('qty', 0);
                    }
                });
            }
        },
        
        safeRender: function () {
            if (!this.isDestroyed) {
                this.render();
            }
        },

        onDomRefresh: function () {
            // @todo let's think how to remove this
            var errors = this.getOption('bookingModel').validationError || {};
            if (errors.global_form) {
                Backbone.Wreqr.radio.vent.trigger('status_message', 'shown');
            } else if (errors && !_.isEmpty(errors)) {
                Backbone.Wreqr.radio.vent.trigger('field_error', 'shown', {
                    'type': 'client_details'
                });
            }
        }

    });

});
